module.exports = __webpack_public_path__ + "static/media/icon-back.c44df0e3.svg";